var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowUp3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3058_10)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.98438 0C13.4004 0 16.9844 3.592 16.9844 8L16.9813 8.22381C16.8626 12.5365 13.3255 16 8.98438 16C4.57637 16 0.984375 12.416 0.984375 8C0.984375 3.592 4.57637 0 8.98438 0ZM5.7844 9.58402C6.0244 9.81602 6.4004 9.81602 6.6324 9.57602L8.9844 7.21602L11.3364 9.57602C11.5684 9.81602 11.9524 9.81602 12.1844 9.58402C12.4244 9.34402 12.4244 8.96802 12.1844 8.73602L9.4084 5.94402C9.2964 5.83202 9.1444 5.76802 8.9844 5.76802C8.8244 5.76802 8.6724 5.83202 8.5604 5.94402L5.7844 8.73602C5.6644 8.84802 5.6084 9.00002 5.6084 9.15202C5.6084 9.31202 5.6644 9.46402 5.7844 9.58402Z",
    fill: "#12233D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3058_10"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp3);
export default __webpack_public_path__ + "static/media/arrow-up3.562f41fccb32f5693e3fecc825ea3178.svg";
export { ForwardRef as ReactComponent };